var React = require('react');

function IconVisualUXDesign (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.5 18C23.7464 18 28 22.2536 28 27.5C28 32.7464 23.7464 37 18.5 37C13.2536 37 9 32.7464 9 27.5","stroke":"#00D664","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18 18.2857V27H1V10H13.1429","stroke":"#00D664","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 18L19.5 1L29 18H10Z","stroke":"#00D664","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

IconVisualUXDesign.defaultProps = {"width":"30","height":"38","viewBox":"0 0 30 38","fill":"none"};

module.exports = IconVisualUXDesign;

IconVisualUXDesign.default = IconVisualUXDesign;
